// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-tabsa{overflow-x:auto;overflow-y:hidden;flex-wrap:nowrap}", ""]);
// Exports
module.exports = exports;
